export interface InvestmentTransactionFields {
  folio_no: string;
  account_number: string;
  account_title: string;
  unitholder_name: string;
  counter_account_title: string;
  counter_account_number: string;
  counter_bank: string;
  counter_branch: string;
  fund_code: string;
  fund_name: string;
  amc_code: string;
  amc_name: string;
  txnr_type: string;
  type: string;
  price: string;
  net_amount: string;
  gross_amount: string;
  discount_on_load: string;
  applicable_unit_load: string;
  current_holding: string;
  total_holding: string;
  sale_load: string;
  nav: string;
  instruction_date: string;
  sale_date: string;
  settlement_date: string;
  bank: string;
  branch: string;
  mode_of_payment: string;
  payment_type: string;
  instrument_type: string;
  instrument_no: string;
  instrument_date: string;
  realized_date: string;
  settlement_by: string;
  detail: string;
  units: string;
  systematic_investment: any;
  txn_id?: string;
  authorization_value?: string;
  authorization_comment?: string;
  txn_status?: string;
  _id?: string;
  tax_cgt?: string;
  tax_wht_it?: string;
  tax_wht_sst?: string;
  tax_type?: string;
  tax_sst?: string;
  tax_other?: string;
  to_scheme?: string;
  from_scheme?: string;
  other_deductions?: number;

  // Withdrawal Transaction Extra Feilds

  wht_payment_code?: string;
  wht_tax_paid_year_1?: number;
  wht_tax_paid_year_2?: number;
  wht_tax_paid_year_3?: number;
  wht_taxable_income_year_1?: number;
  wht_taxable_income_year_2?: number;
  wht_taxable_income_year_3?: number;
  wht_taxable_amount?: number;
}

export const defaultFields = (today) => ({
  folio_no: "",
  account_number: "",
  account_title: "",
  unitholder_name: "",
  counter_account_title: "",
  counter_account_number: "",
  counter_bank: "",
  counter_branch: "",
  fund_code: "",
  fund_name: "",
  amc_code: "",
  amc_name: "",
  txnr_type: "",
  type: "credit",
  price: "",
  net_amount: "",
  gross_amount: "",
  discount_on_load: "",
  applicable_unit_load: "",
  current_holding: "",
  total_holding: "",
  sale_load: "",
  nav: "",
  instruction_date: today,
  sale_date: today,
  settlement_date: today,
  bank: "",
  branch: "",
  mode_of_payment: "",
  payment_type: "Direct Credit",
  instrument_type: "",
  instrument_no: "",
  instrument_date: today,
  realized_date: today,
  settlement_by: "",
  detail: "",
  units: "",
  to_scheme: "",
  from_scheme: "",
  systematic_investment: null,
  tax_cgt: "0",
  tax_wht_it: "0",
  tax_wht_sst: "0",
  tax_type: "0",
  tax_sst: "0",
  tax_other: "0",
  wht_payment_code: "",
  other_deductions: 0,
  wht_tax_paid_year_1: 0,
  wht_tax_paid_year_2: 0,
  wht_tax_paid_year_3: 0,
  wht_taxable_income_year_1: 0,
  wht_taxable_income_year_2: 0,
  wht_taxable_income_year_3: 0,
  wht_taxable_amount: 0,
});

export const vpsTxns = ["investment", "withdrawal", "changeofallocation"];
